import React from "react";

const Location = ({ goNext, goBack }) => {
  return (
    <div>
      <h2>Location</h2>
      {/* Your form inputs here */}
      <button onClick={goBack}>Back</button>
      <button onClick={goNext}>Next</button>
    </div>
  );
};

export default Location;
